import { getState, getStatePure, modifyState } from '~src/state';
import { exportIMG } from '~core';
import { addPagesToSidebar } from '~src/multipages';
import { getMultiplier } from '~src/utils';

export const generateCurrentPageThumbnail = async () => {
  if (getState('isErasing', false)) {
    return;
  }
  if (getState('isExporting', false)) {
    return;
  }
  const canvas = window.canvas;
  if (!canvas || typeof canvas.getZoom !== 'function') {
    console.warn(
      'Cannot generate current page thumbnail',
      new Error('Canvas is not ready')
    );
    return;
  }

  const isZoomed = canvas.getZoom();
  if (isZoomed !== 1) {
    return;
  }
  const pages = getStatePure('pages');
  const project = getState('selected.tipo');
  const currentPageIndex = getState('currentPageIndex', 0);

  if (pages.length > 0) {
    try {
      const preview = exportIMG(
        0.92,
        project.outputDpi,
        'base64',
        'jpeg',
        true,
        getMultiplier()
      );
      await modifyState(`pages[${currentPageIndex}].imgData`, preview.base64);
    } catch (error) {
      console.warn('Cannot generate current page thumbnail', error);
    }
    await addPagesToSidebar();
  }
};
